module.exports = __webpack_public_path__ + "img/MTC.a03323df.jpg";